// extracted by mini-css-extract-plugin
module.exports = {"cases":"styles_cases__t2cQI","image":"styles_image__CiVNn","pulse":"styles_pulse__Ikxoo","spin":"styles_spin__7HkWk"};